import { getAuthContext } from "./authContext";
import type { AuthDescriptor } from "./authDescriptor";
import type { AuthSpec, PrivateAuthApp } from "./types";

export function resolveAuth(
  spec: AuthSpec,
  app: PrivateAuthApp
): AuthDescriptor {
  if (typeof spec !== "function") return spec;
  return spec({ ...getAuthContext(), ...app });
}
